import { QuoteCms } from '@common/util-models';
import { CmsAsset } from '@domgen/dgx-fe-business-models';

export type ApplianceCode = 'QK';

export const getCmsData = (isEngineerJourney: boolean | null) =>
  isEngineerJourney ? mockEngineerJourneyCms : mockSalesJourneyCms;

export const mockSalesJourneyCms = {
  QK: {
    box: {
      title: 'Sky Q',
      img: './assets/images/sky-q-box.png',
      imgAlt: 'Sky+Q',
      desc: 'Cover your Sky Q equipment and three devices of your choice',
    },
    quoteCms: {
      termsAndConditionsAsset: {} as CmsAsset,
      ipidAsset: {} as CmsAsset,
      banner: '',
      planDurationHeading: '',
      planDurationBody: '',
      needToKnow:
        '<p>This insurance policy meets the demands and needs of those who wish to insure their Sky equipment, television sets, tablets, laptops, consoles and/or mobiles against breakdown, accidental damage. By taking up this policy, you agree this product meets your demands and needs.<p><br/><p>Full details on how to submit a complaint can be found in the <span><a class="link" target="_blank" download href="cms_data/pdfs/Sky_Terms_Conditions_SKGM_1222.pdf" title="Terms & Conditions">Sky Q Protect policy terms and conditions</a></span>.</p>',
      included: [
        'Your chosen devices and all Sky Q equipment in your household',
        'Accidental damage',
        'Breakdowns',
        'Unlimited repairs and replacements',
        'Worldwide cover (claims will be resolved in the UK)',
        'Exclusive next-day priority service for your core Sky Q equipment*',
      ],
      excluded: [
        'Loss and theft for your Sky Q equipment and your device(s) (unless added/available for a mobile phone)',
        'Cosmetic or malicious damage',
        'Commercial use',
        'Disposal and setup costs for your device(s) in the event of a replacement',
      ],
      insurance:
        '<p>*Tell us about a problem by 4pm, and if we can’t fix your core Sky equipment the next day, we’ll refund you a week’s Sky TV subscription. Excludes special heights and premises difficult to access safely, North Highlands, and Islands.</p><p>&nbsp;</p><p>While you can get your loaned equipment repaired or replaced under your Sky Q contract, this won’t apply to accidental damage or anything other than your box, hub and supplied remotes.</p><p>&nbsp;</p><p>Your chosen device must have cost less than £2,000 when new and be in good working order. Please see the <a class="link" target="_blank" download href="cms_data/pdfs/Sky_Terms_Conditions_SKGM_1222.pdf" title="Terms &amp; Conditions">Sky Q Protect policy terms and conditions</a> and <a class="link" target="_blank" download href="cms_data/pdfs/Sky_IPID.pdf" title="Insurance Product Information Document">Sky Q Protect Insurance Product Information Document</a> for full details.</p>',
      title: 'Cover three devices and your Sky Q equipment for',
      freePeriodTitle: 'Then cover three devices and your Sky Q equipment for',
      jcrName: 'policy-features-1',
      formName: 'policy-features-1',
    } as QuoteCms,
  },
  VIRTUAL: {
    box: {
      title: 'Sky Glass',
      img: './assets/images/devices/Sky Virtual Box.png',
      imgAlt: 'Devices',
      desc: 'Cover your Sky Glass and two devices of your choice',
    },
    mobile: {
      desc: 'Cover your mobile',
      excluded: [
        'Loss and theft (unless added to a mobile phone)',
        'Cosmetic and malicious damage',
        'Commercial use',
        'Disposal and setup costs for your device(s) in the event of a replacement',
      ],
      excludedTitle: `What's not included?`,
      img: './assets/images/devices/Mobile Phone.png',
      imgAlt: 'Mobile',
      included: [
        'Accidental damage',
        'Breakdowns',
        'Unlimited repairs and replacements',
        'Worldwide cover (claims will be resolved in the UK)',
      ],
      includedTitle: `What's included?`,
      insurance:
        'Please see the <a class="link" target="_blank" download href="cms_data/pdfs/Sky_Mobile_Terms_Conditions.pdf" title="Terms &amp; Conditions">Sky Protect Mobile Insurance policy terms and conditions</a> and <a class="link" target="_blank" download href="cms_data/pdfs/Sky_Mobile_IPID.pdf" title="Insurance Product Information Document">Sky Protect Mobile Insurance Product Information Document</a> for full details.</p>',
      needToKnow:
        '<p>This insurance policy meets the demands and needs of those who wish to insure their mobiles against breakdown, accidental damage, and (if selected) loss and theft. By taking up this policy, you agree this product meets your demands and needs.<p><br/><p>Full details on how to submit a complaint can be found in the <span><a class="link" target="_blank" download href="cms_data/pdfs/Sky_Mobile_Terms_Conditions.pdf" title="Terms & Conditions">Sky Protect Mobile Insurance policy terms and conditions.</a></span>.</p>',
      title: 'Mobile phone',
    },
    quoteCms: {
      termsAndConditionsAsset: {} as CmsAsset,
      ipidAsset: {} as CmsAsset,
      banner: '',
      planDurationHeading: '',
      planDurationBody: '',
      needToKnow:
        '<p>This insurance policy meets the demands and needs of those who wish to insure their Sky equipment, television sets, tablets, laptops, consoles and/or mobiles against breakdown, accidental damage. By taking up this policy, you agree this product meets your demands and needs.<p><br/><p>Full details on how to submit a complaint can be found in the <span><a class="link" target="_blank" download href="cms_data/pdfs/Sky_Terms_Conditions_SKGM_1222.pdf" title="Terms & Conditions">Sky Protect policy terms and conditions</a></span>.</p>',
      included: [
        'Your chosen devices and Sky Glass equipment in your household',
        'Accidental damage',
        'Breakdowns',
        'Unlimited repairs and replacements',
        'Worldwide cover (claims will be resolved in the UK)',
      ],
      excluded: [
        'Sky Glass and Sky equipment',
        'Loss and theft for your equipment and your device(s) (unless added/available for a mobile phone)',
        'Cosmetic or malicious damage',
        'Commercial use',
        'Disposal and setup costs for your device(s) in the event of a replacement',
      ],
      insurance:
        'Please see the <a class="link" target="_blank" download href="cms_data/pdfs/Sky_Terms_Conditions_SKGM_1222.pdf" title="Terms &amp; Conditions">Sky Protect policy terms and conditions</a> and <a class="link" target="_blank" download href="cms_data/pdfs/Sky_IPID.pdf" title="Insurance Product Information Document">Sky Protect Insurance Product Information Document</a> for full details.</p>',
      title: 'Cover two devices and your Sky Glass for',
      freePeriodTitle: 'Then cover two devices and your Sky Glass for',
      jcrName: 'policy-features-1',
      formName: 'policy-features-1',
    } as QuoteCms,
  },
  Television: {
    text: `Only Sky Glass Systems registered to your Sky account will be eligible for protection`,
  },
};

const mockEngineerJourneyCms = {
  QK: {
    box: {
      title: 'Sky Q',
      img: './assets/images/sky-q-box.png',
      imgAlt: 'Sky+Q',
      desc: 'Cover your Sky Q equipment and two devices of your choice',
    },
    quoteCms: {
      termsAndConditionsAsset: {} as CmsAsset,
      ipidAsset: {} as CmsAsset,
      banner: '',
      planDurationHeading: '',
      planDurationBody: '',
      needToKnow:
        '<p>This insurance policy meets the demands and needs of those who wish to insure their Sky equipment, television sets, tablets, laptops, consoles and/or mobiles against breakdown, accidental damage. By taking up this policy, you agree this product meets your demands and needs.<p><br/><p>Full details on how to submit a complaint can be found in the <span><a class="link" target="_blank" download href="cms_data/pdfs/Sky_Terms_Conditions_SKGM_1222.pdf" title="Terms & Conditions">Sky Q Protect policy terms and conditions</a></span>.</p>',
      included: [
        'Your chosen devices and all Sky Q equipment in your household',
        'Accidental damage',
        'Breakdowns',
        'Unlimited repairs and replacements',
        'Worldwide cover (claims will be resolved in the UK)',
        'Exclusive next-day priority service for your core Sky Q equipment*',
      ],
      excluded: [
        'Loss and theft for your Sky Q equipment and your device(s) (unless added/available for a mobile phone)',
        'Cosmetic or malicious damage',
        'Commercial use',
        'Disposal and setup costs for your device(s) in the event of a replacement',
      ],
      insurance:
        '<p>*Tell us about a problem by 4pm, and if we can’t fix your core Sky equipment the next day, we’ll refund you a week’s Sky TV subscription. Excludes special heights and premises difficult to access safely, North Highlands, and Islands.</p><p>&nbsp;</p><p>While you can get your loaned equipment repaired or replaced under your Sky Q contract, this won’t apply to accidental damage or anything other than your box, hub and supplied remotes.</p><p>&nbsp;</p><p>Your chosen device must have cost less than £2,000 when new and be in good working order. Please see the <a class="link" target="_blank" download href="cms_data/pdfs/Sky_Terms_Conditions_SKGM_1222.pdf" title="Terms &amp; Conditions">Sky Q Protect policy terms and conditions</a> and <a class="link" target="_blank" download href="cms_data/pdfs/Sky_IPID.pdf" title="Insurance Product Information Document">Sky Q Protect Insurance Product Information Document</a> for full details.</p>',
      title: 'Cover two devices and your Sky Q equipment for',
      freePeriodTitle: 'Then cover two devices and your Sky Q equipment for',
      jcrName: 'policy-features-1',
      formName: 'policy-features-1',
    } as QuoteCms,
  },
};
